import styled from '@emotion/styled';
import { breakpoints, space } from '@airwallex/global';
import * as colors from '@airwallex/colors';
import { css } from '@emotion/core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space.m};
  align-self: stretch;
`;

export const InvoicePanel = styled.div<{ isOnePageLayout: boolean }>`
  width: 100%;
  background: ${colors.grays[5]};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  ${({ isOnePageLayout }) =>
    isOnePageLayout &&
    css`
      min-height: 100vh;
    `}
`;

export const InvoiceContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.m};
  width: 100%;
  min-width: 360px;
  max-width: 472px;
  padding: ${space.xl} ${space.s};
  @media (min-width: ${breakpoints.breakpointTokens.xs + 1}px) {
    padding: ${space.xl} ${space.m};
    min-width: 376px;
    max-width: 488px;
  }
`;

export const PaymentPanel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space.m};
`;

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.m};
  width: 100%;
  min-width: 360px;
  max-width: 472px;
  padding: 0 ${space.s};
  @media (min-width: ${breakpoints.breakpointTokens.xs + 1}px) {
    padding: 0 ${space.m};
    min-width: 376px;
    max-width: 488px;
  }
`;
